<template>
    <div class="backend-test">
      <h2>Backend Connection Test</h2>
      <button @click="fetchData">Fetch Data</button>
      <pre v-if="responseData">{{ responseData }}</pre>
    </div>
  </template>
  
  <script>
  import axios from 'axios';
  
  export default {
    data() {
      return {
        responseData: null,
      };
    },
    methods: {
      async fetchData() {
        try {
          const response = await axios.get("http://34.16.161.220:3000/test-frontend-connection");
          console.log("✅ Backend Response:", response.data);
          this.responseData = JSON.stringify(response.data, null, 2);
        } catch (error) {
          console.error("❌ Error fetching data:", error);
          this.responseData = "Error fetching data.";
        }
      },
    },
  };
  </script>
  
  <style scoped>
  .backend-test {
    text-align: center;
    margin-top: 20px;
  }
  pre {
    background: #f4f4f4;
    padding: 10px;
    border-radius: 5px;
    text-align: left;
  }
  </style>
  